module.exports = __webpack_public_path__ + "components/flag/static/square/sz-3ba7dcd40e58bcbe66d7eb12aebdc713.svg";